import { IconNames } from '@blueprintjs/icons';
import { BenefitTypeDisplayTextMap } from '@strata/constants';
import { formatDate } from '@strata/helper-functions';
import { FormSectionWithRows } from '@strata/react-form-section';
import { GridWithSearch } from '@strata/react-grid';
import { DetailLabelValuePair } from '@strata/react-label-value-pairs';
import { Icon } from '@strata/react-status-icons';
import { Tag } from '@strata/react-tags';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { ProductExpansionColumns } from 'pages/goLives/ProductExpansionSupport';

export const ProductExpansion = ({ productExpansion, segmentId, navigate }) => (
    <FormSectionWithRows
        sectionTitle={
            <span className="flex__gap--small">
                {productExpansion.product_expansion_name}
                <Tag label="Product Expansion" />
                <Tag label={BenefitTypeDisplayTextMap[productExpansion.benefit]} />
            </span>
        }
        rightHeaderContent={
            <Icon
                icon={IconNames.EDIT}
                intent={Icon.Intent.SECONDARY}
                title="Edit"
                onClick={() => {
                    navigate({
                        pathname: `/go-lives/${segmentId}/product-expansion/${productExpansion.product_expansion_id}`,
                    });
                }}
            />
        }
        rowOneContent={
            <>
                <DetailLabelValuePair
                    label="Platform Start Date"
                    value={formatDate(productExpansion.product_expansion_date)}
                />
                <DetailLabelValuePair
                    label="Outreach Date"
                    value={formatDate(productExpansion.outreach_date)}
                />
                <DetailLabelValuePair
                    label="Go-Live Date"
                    value={formatDate(productExpansion.go_live_date)}
                />
            </>
        }
        rowTwoContent={
            <>
                <div className={classNames('padding__bottom--small', 'font-semi-bold')}>
                    Product Details
                </div>
                <div style={{ maxHeight: 350, width: '100%', overflow: 'auto' }}>
                    <GridWithSearch
                        columns={ProductExpansionColumns}
                        data={productExpansion.product_service_oids.map((oid) => ({ oid }))}
                        sortProperties={[{ id: 'oid', desc: false }]}
                    />
                </div>
            </>
        }
        rowTwoFlexDirection="column"
    />
);

ProductExpansion.propTypes = {
    productExpansion: PropTypes.shape({
        product_expansion_id: PropTypes.string.isRequired,
        product_expansion_name: PropTypes.string.isRequired,
        product_expansion_date: PropTypes.string.isRequired,
        outreach_date: PropTypes.string.isRequired,
        go_live_date: PropTypes.string.isRequired,
        benefit: PropTypes.string.isRequired,
        segment_ref_id: PropTypes.string.isRequired,
        segment_id: PropTypes.string.isRequired,
        product_service_oids: PropTypes.arrayOf(PropTypes.string).isRequired,
    }).isRequired,
    segmentId: PropTypes.string.isRequired,
    navigate: PropTypes.func.isRequired,
};
